import { useEffect } from "react";
import type { ReactNode } from "react";
import { Container } from "@mui/material";
import { useNavigate } from "react-router";
import { routesConfig } from "app-config";
import storageService from "services/storageService";

/**
 * Page appelée après déconnexion de l'utilisateur sur la platefome Microsoft Online
 */
function FlushPage(): ReactNode {
  const navigate = useNavigate();

  useEffect(() => {
    storageService.removeUserInfo();
    navigate(routesConfig.home.path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Container maxWidth="md">Vous êtes à présent déconnecté.</Container>;
}

export default FlushPage;
